import { FormDialog } from "../../components/FormDialog/FormDialog";

const EventsDialog = ({ formId, readOnly, saveEventsData, eventSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            schema={eventSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveEventsData}
        />
    );

}

export default EventsDialog;
